/**
 * Get hours in decimal format
 * @todo could improve a bit for rounding and our handling only .25 increments (15 m)
 */
export const getDecimalHours = (hours: number): number => Number(hours.toFixed(2));
